<template>
    <div>
        <v-select v-model="filter.type" :items="types" item-text="text" item-value="value" label="검색 타입" dense hide-details outlined class="d-inline-block" @input="page = 1, search()" />

        <table width="100%" class="mt-4">
            <thead>
                <tr>
                    <th>날짜</th>
                    <th>타입</th>
                    <th>비고</th>
                    <th>이용금액</th>
                    <th>남은잔액</th>
                </tr>
            </thead>
            <tbody>
                <template v-for="point, index in points">
                    <tr :key="index">
                        <td>{{ $dayjs(point.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</td>
                        <td>{{ point.type }}</td>
                        <td>{{ point.remark }}</td>
                        <td>{{ point.amount.format() }}</td>
                        <td>{{ point.remain.format() }}</td>
                    </tr>
                </template>
            </tbody>
        </table>

        <v-pagination v-model="page" :length="pageCount" total-visible="11" @input="search()" class="mt-4"/>
    </div>
</template>

<script>
import api from "@/api";

export default {
    data(){
        return {
            filter: {
                type: null
            },

            page: 1,
            pageCount: 0,
            limit: 10,

            summary: { totalCount: 0 },
            points: [],

            types: [
                { text: ":: 전체 ::", value: null },
                { text: "충전", value: "charge" },
                { text: "사용", value: "use" },
            ]
        }
    },
    mounted(){
        this.search();
    },
    methods: {
        async search(){
            let { summary, points } = await api.v1.me.points.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit,
                },
                params: this.filter
            });

            this.points = points;
            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        }
    }
}
</script>